/**
 * Stable avatar color for things that are not core contacts (so no
 * core-assigned color exists): public-bot directory entries, names parsed
 * out of invite links, etc.
 */
export function colorFromString(str: string): string {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0
  }
  return `hsl(${((hash % 360) + 360) % 360}, 54%, 46%)`
}
